export const DEFAULT_APPEARANCE_CONFIG = {
    "Logo": "https://pre-centralized.vidsigner.net/logo-vid-sit.png",
    "PrimaryColor": "#00bf71",
    "PrimaryTextColor": "#FFFFFF",
    "SecondaryColor": "#00bf71",
    "SecondaryTextColor": "#FFFFFF"
};